module.exports = __webpack_public_path__ + "assets/media/evening.56140bdc.mp3";